export default {
  setList (state, payload) {
    state.list = payload
  },

  toggle () {}
}
